import $ from 'jquery';
import React from 'react';

import {pluralize} from 'BenchlingUtil';
import * as BatchGuideDesignDAO from 'molbio/crispr/BatchGuideDesignDAO';
import notifications from 'notifications';
import {ListableItem} from 'search/SearchConstants';
import Modal from 'ui-library/modals/Modal';
import {readableTime} from 'util/DateUtil';
import * as modals from 'util/Modals';

import SetDefaultsInput from './SetDefaultsInput';
// @ts-expect-error
import SettingsForm from './SettingsForm';

interface BatchCRISPRModalProps {
  onRequestClose: () => void;
  sequences: Array<ListableItem>;
}

interface BatchCRISPRModalState {
  batchGuideDesignLoading: boolean;
  valid: boolean;
}

class BatchCRISPRModal extends React.Component<BatchCRISPRModalProps, BatchCRISPRModalState> {
  state: BatchCRISPRModalState = {
    batchGuideDesignLoading: false,
    valid: true,
  };

  setDefaultsInputRef = React.createRef<SetDefaultsInput>();
  settingsFormRef = React.createRef<SettingsForm>();

  submitBatchDesign = (): void => {
    this.setDefaultsInputRef.current!.setDefaults(this.settingsFormRef.current.getAllSettings());
    const sequenceIds = this.props.sequences.map(({id}) => id);
    // Warn the user if there are existing analyses that would be deleted
    BatchGuideDesignDAO.checkSequenceCRISPRStats({sequenceIds}).done(
      ({sequences}: BatchGuideDesignDAO.CheckCRISPRStatsResponse) => {
        let promise;
        const sequencesWithAnalyses = sequences.filter(
          ({numCrisprAnalyses}: {numCrisprAnalyses: number}) => numCrisprAnalyses > 0
        );
        if (sequencesWithAnalyses.length > 0) {
          const component = (
            <div>
              <p>
                {`Running batch CRISPR analyses will overwrite existing CRISPR analyses on the \
  following sequences. Are you sure you want to continue?`}
              </p>
              <ul>
                {sequencesWithAnalyses.map((sequence: BatchGuideDesignDAO.CRISPRStatsSequence) => (
                  <li key={sequence.name}>{sequence.name}</li>
                ))}
              </ul>
            </div>
          );
          promise = modals.confirm('Confirm overwrite CRISPR analyses', component);
        } else {
          promise = $.Deferred().resolve().promise();
        }
        promise.done(() => {
          this.setState({batchGuideDesignLoading: true});
          return BatchGuideDesignDAO.scoreGuides({
            sequenceIds,
            startTime: readableTime(new Date()),
            ...this.settingsFormRef.current.getAnalysisSettings(),
            name: 'Batch CRISPR',
          })
            .always(() => {
              this.setState({batchGuideDesignLoading: false});
            })
            .done(() => {
              notifications.success(`Submitted batch design for ${this.props.sequences.length} \
${pluralize(this.props.sequences.length, 'sequence')}, you will receive an \
email when complete.`);
              this.props.onRequestClose();
            })
            .fail(notifications.notifyError);
        });
      }
    );
  };

  render(): JSX.Element {
    const buttons = [
      {
        text: this.state.batchGuideDesignLoading ? 'Submitting...' : 'Run analyses',
        submit: true,
        disabled: this.state.batchGuideDesignLoading || !this.state.valid,
      },
    ];
    return (
      <Modal
        title="Batch CRISPR analyses settings"
        onRequestSubmit={this.submitBatchDesign}
        onRequestClose={this.props.onRequestClose}
        buttons={buttons}
        footer={React.createElement(SetDefaultsInput, {
          disabled: false,
          initialShouldSetDefaults: false,
          ref: this.setDefaultsInputRef,
        })}
      >
        <SettingsForm
          setValid={(valid: boolean) => {
            this.setState({valid});
          }}
          allowEdits={true}
          ref={this.settingsFormRef}
        />
      </Modal>
    );
  }
}

export default BatchCRISPRModal;
